"use client";
import { FocusableContext } from "./focusable-context.js";
import { createElement, createHook, forwardRef, useWrapElement } from "@ariakit/react-utils";
import { jsx } from "react/jsx-runtime";
//#region src/focusable/focusable-container.tsx
const TagName = "div";
/**
* Returns props to create a `FocusableContainer` component.
* @see https://ariakit.com/components/focusable
* @example
* ```jsx
* const props = useFocusableContainer();
* <Role {...props} />
* ```
*/
const useFocusableContainer = createHook(function useFocusableContainer({ autoFocusOnShow = true, ...props }) {
	props = useWrapElement(props, (element) => /* @__PURE__ */ jsx(FocusableContext.Provider, {
		value: autoFocusOnShow,
		children: element
	}), [autoFocusOnShow]);
	return props;
});
/**
* Renders a div that wraps
* [`Focusable`](https://ariakit.com/reference/focusable) components and
* controls whether they can be auto-focused.
* @see https://ariakit.com/components/focusable
* @example
* ```jsx
* <FocusableContainer autoFocusOnShow={false}>
*   <Focusable autoFocus />
* </FocusableContainer>
* ```
*/
const FocusableContainer = forwardRef(function FocusableContainer(props) {
	return createElement(TagName, useFocusableContainer(props));
});
//#endregion
export { FocusableContainer, useFocusableContainer };

//# sourceMappingURL=focusable-container.js.map